var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project-list-page" }, [
    _c(
      "div",
      { staticClass: "project-list-toolbar" },
      [
        _c(
          "portal-filter-bar",
          {
            attrs: { label: _vm.$t("global.filter") },
            scopedSlots: _vm._u([
              {
                key: "summary",
                fn: function() {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.filteredProjects.length) +
                        " " +
                        _vm._s(_vm.$t("projects.page-heading")) +
                        " "
                    )
                  ]
                },
                proxy: true
              }
            ])
          },
          [
            _c("portal-search-field", {
              attrs: {
                label: _vm.$t("global.filter"),
                placeholder: _vm.$t("global.filter"),
                "clear-label": _vm.$t("global.clear")
              },
              model: {
                value: _vm.projectFilter,
                callback: function($$v) {
                  _vm.projectFilter = $$v
                },
                expression: "projectFilter"
              }
            }),
            _c("portal-select-field", {
              attrs: {
                label: _vm.$t("projects.filter.status"),
                options: _vm.projectStatusOptions
              },
              model: {
                value: _vm.projectStatus,
                callback: function($$v) {
                  _vm.projectStatus = $$v
                },
                expression: "projectStatus"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm.isReady
      ? _c("div", { staticClass: "project-list-content show-scrollbar" }, [
          _vm.filteredProjects.length
            ? _c(
                "div",
                { staticClass: "project-grid" },
                _vm._l(_vm.filteredProjects, function(project) {
                  return _c(
                    "router-link",
                    {
                      key: project.id,
                      staticClass: "project-card",
                      attrs: { to: "/projects/" + project.id }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "project-card-top" },
                        [
                          _c(
                            "span",
                            { staticClass: "project-icon" },
                            [
                              _c("portal-icon", {
                                attrs: { name: "folder-kanban", size: 21 }
                              })
                            ],
                            1
                          ),
                          _c(
                            "portal-status-pill",
                            {
                              attrs: {
                                background: project.active
                                  ? "var(--v-success_10-base)"
                                  : "var(--v-gray_20-base)",
                                color: project.active
                                  ? "var(--v-success-base)"
                                  : "var(--portal-muted)"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(_vm.projectStatusKey(project))
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "project-card-copy" }, [
                        _c("h2", [_vm._v(_vm._s(project.name))]),
                        project.dueDate
                          ? _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("global.due")) +
                                  " " +
                                  _vm._s(_vm.formatProjectDueDate(project)) +
                                  " "
                              )
                            ])
                          : _c("p", [
                              _vm._v(_vm._s(_vm.$t("projects.no-due-date")))
                            ])
                      ]),
                      _c(
                        "div",
                        { staticClass: "project-card-action" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("projects.overview.heading")))
                          ]),
                          _c("portal-icon", {
                            attrs: { name: "arrow-right", size: 18 }
                          })
                        ],
                        1
                      )
                    ]
                  )
                }),
                1
              )
            : _c("div", { staticClass: "project-list-empty" }, [
                _c(
                  "span",
                  { staticClass: "project-icon" },
                  [
                    _c("portal-icon", {
                      attrs: { name: "folder-kanban", size: 22 }
                    })
                  ],
                  1
                ),
                _c("p", [_vm._v(_vm._s(_vm.$t("timetrack.no-projects")))])
              ])
        ])
      : _c(
          "div",
          { staticClass: "project-list-loading" },
          [
            _c("v-progress-circular", {
              attrs: { indeterminate: "", size: 38, width: 3, color: "primary" }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }